import { render } from "./modal-task-project-select.vue?vue&type=template&id=6a04f168&scoped=true"
import script from "./modal-task-project-select.vue?vue&type=script&lang=js"
export * from "./modal-task-project-select.vue?vue&type=script&lang=js"

import "./modal-task-project-select.vue?vue&type=style&index=0&id=6a04f168&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a04f168"]])

export default __exports__